/*-----------------------------------------------------------------------------/
/ Custom Theme JSifram
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...





// Magnific Popup
// Theme by default disables it when "PAGE TRANSITIONS" is enabled
// https://dimsemenov.com/plugins/magnific-popup/documentation.html

// Pop up (content) type is determined by "mfp-TYPE" in class. Available types: image, iframe, inline, and ajax.
// EX: class="rab-mfp mfp-image"
$('.rab-mfp').magnificPopup({
  image: {
    titleSrc: 'title'
  },
  iframe: {
    markup: '<div class="mfp-iframe-scaler">'+
              '<div class="mfp-close"></div>'+
              '<iframe class="mfp-iframe" frameborder="0" allow="autoplay" allowfullscreen></iframe>'+
            '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

    patterns: {
      youtube: {
        index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
        id: 'v=', // String that splits URL in a two parts, second part should be %id%
        src: '//www.youtube-nocookie.com/embed/%id%?autoplay=1&iv_load_policy=3&modestbranding=1&showinfo=0' // URL that will be set as a source for iframe.
      }
    },
    srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
  },
  mainClass: "rab-mfp-inline-popup", // works with .mfp
  fixedContentPos: true
});

/*
$(document).ready(function () {
  $('img:not([alt])').attr('alt', '');
  $('img[src*="icon_download_on_appstore"]').attr('alt','Download on the App Store');
  $('img[src*="icon_works_with_alexa"]').attr('alt','Works with Alexa');
  $('img[src*="icon_get_it_on_google_store"]').attr('alt','Get it on Google Play');
  $('img[src*="noiselevel_chart"]').attr('alt','Bar chart of noise levels compared to Rabbit Air on silent speed: Breathing (~10 dBA); Clock tick (~19 dBA); MinusaA2 700A (~20 dBA); BioGS 550A (~23 dBA); Whispering (~30 dBA); Library environment (~40 dBA); Conversation (>60 dBA).');
  $('img[src*="minusa2_operate_cost"]').attr('alt','Bar chart of operating cost for air purifiers on the market: Rabbit Air BioGS 550A (~$80); Rabbit Air MinusA2 700A (~$130); Honeywell HPA300 (~$225); Whirlpool WPPRO2000 (~$275); Blueair Classic 480i (~$400); IQAir HP Compact Plus (>$450);');
  $('img[src*="a3_a2_gs_operate_cost"]').attr('alt','Bar chart of operating cost for air purifiers on the market: Rabbit Air BioGS 550A (~$80); Rabbit Air MinusA2 780A/N (~$150); Rabbit Air A3 1000N (~$175); Honeywell HPA300 (~$225); Whirlpool WPPRO2000 (~$275); Blueair Classic 480i (~$400); IQAir HP Compact Plus (>$450);');
});
*/


// Slick slides, add param in attr data-slick
$('.js-rab-slick, .rab__slick').slick();

// Unhide ele, then scroll to it
$('.js-rab-show-and-scroll').click(function(){  	

	var activeClassName = 'js-active';
	var contentEleId = $(this).attr('href');
	var contentEle = $( contentEleId );
  
	if ( !contentEle ) return; // Do nothing if no element found

	var scrollOffset = ($(".js-header").hasClass("js-header-sticky")) ? 118 : 18;

  	// hide content
	if ( contentEle.hasClass( activeClassName ) ) {
		contentEle.hide();
		contentEle.removeClass( activeClassName );
      	$(this).attr('aria-expanded', 'false')
    } else {
      // show + scroll
		contentEle.show();
		$("html,body").animate({
          scrollTop: contentEle.offset().top - 110
        },800);
		contentEle.addClass( activeClassName );
      	$(this).attr('aria-expanded', 'true')
    }
  
	return false;
});



function loadScript(url, callback) {  
  var script = document.createElement( "script" )
  script.type = "text/javascript";
  if(script.readyState) {  // IE <9
    script.onreadystatechange = function() {      
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback('loaded');
      }
    };
  } else {  //Others
    script.onload = function() {
      callback('loaded');
    };
    script.onerror = function() {
      callback('error');
    };
  }
  script.src = url;
  document.getElementsByTagName( "head" )[0].appendChild( script );
}


